import React, { useState } from 'react'
import { GoogleMap, LoadScript } from '@react-google-maps/api';
const containerStyle = {
  width: '400px',
  height: '400px'
};

const center = {
  lat: 19.18765461971069,
  lng: 72.87400692603242
};


const Contact = () => {
  const [name,setName]=useState('');
  const [email,setEmail]=useState('');
  const [subject,setSubject]=useState('');
  const [body,setBody]=useState('');
  
  const Emailcall=()=>{
    console.warn(name,typeof(email),subject);
  const sends={
    SecureToken :"a2ccdd0d-ee90-4d6f-8c47-0049fe127bc9",
    port:'2525',
    To : 'prashant.alphaai@gmail.com',//rg mail
    From : "kalambeprashantkp@gmail.com",
    Subject : subject,
    Body : body
  }
  const conformation={
    SecureToken :"a2ccdd0d-ee90-4d6f-8c47-0049fe127bc9",
    port:'2525',
    
    To : email,
    From : "kalambeprashantkp@gmail.com",
    Subject : "Thanks to reach out to our team.",
    Body : "Hi " +name +".Thanks to reach out.Our Team is working on it.Team will replay shortly."
  }
  if(window.Email){
    window.Email.send(sends)
    window.Email.send(conformation)
  }
  }
  return (
    <div >
    <div class="w3-content w3-container w3-padding-64" id="contact">
  <h3 class="w3-center">Contact Us</h3>

{/* <div>
<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30145.37736733009!2d72.866736!3d19.187681!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b75879dfbad7%3A0x92286d0272bc3389!2sR.G.%20Enterprises!5e0!3m2!1sen!2sus!4v1681054159634!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

  {/* <div class="w3-row w3-padding-32 w3-section">
    <div class="w3-col m4 w3-container">
    <LoadScript class="w3-image w3-round" style={{width:"100%" }}
        googleMapsApiKey="AIzaSyAWeF1fSdxPgShP4oVmOeUmbIM2HIbbtoE"
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={10}
        >
          <></>
        </GoogleMap>
      </LoadScript>
     
    </div> */} */}
    <div class="w3-right">
    <div class="w3-col m8 w3-panel">
      <div class="w3-large w3-margin-bottom">
        <i class="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right"></i> 2/Vanashri, Popat Compound, Appapada, Maharashtra Nagar Kurar Village,Malad East Mumbai, Maharashtra 400097 India<br/>
        <i class="fa fa-phone fa-fw w3-hover-text-black w3-xlarge w3-margin-right"></i> Phone:+91 81080608180<br/>
        <a href='https://mail.google.com/mail/u/1/#inbox'><i class="fa fa-envelope fa-fw w3-hover-text-black w3-xlarge w3-margin-right"></i></a> rupesh.rgenterprises@gmail.com<br/>
      </div>
      <p>For any queries please fell free to Email us </p>
      <form >
        <div class="w3-row-padding" style={{margin:"0 -16px 8px -16px" }}>
          <div class="w3-half">
            <input class="w3-input w3-border" type="text" placeholder="Name" required name="Name" value={name} onChange={(e)=>setName(e.target.value)} />
          </div>
          <div class="w3-half">
            <input class="w3-input w3-border" type="text" placeholder="Email" required name="Email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
          </div>
        </div>
        <input class="w3-input w3-border" type="text" placeholder="Message" required name="Message" value={body} onChange={(e)=>setBody(e.target.value)}/>
        <button class="w3-button w3-black w3-right w3-section" type="submit" onClick={Emailcall}>
          <i class="fa fa-paper-plane" ></i> SEND MESSAGE
        </button>
      </form>
      </div>
    </div>
  </div>
</div>
    
    

//     <LoadScript
//         googleMapsApiKey="AIzaSyAWeF1fSdxPgShP4oVmOeUmbIM2HIbbtoE"
//       >
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={center}
//           zoom={10}
//         >
//           <></>
//         </GoogleMap>
//       </LoadScript> */}
//       <table className='tableContact'>
//         <tr>
//           <td className='mapss'>  <iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=12/Vanashri, Popat Compound, Appapada, Maharashtra Nagar Kurar Village, Malad East Mumbai, Maharashtra 400097 India&t=&z=14&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
// </td>
// <td className='contactbox'>
// <h3>Contact Us</h3>
// Name <input type="text" placeholder='Enter your Name..' className='input-contact' value={name} onChange={(e)=>setName(e.target.value)}></input><br/>
//    Email <input type="text" placeholder='Enter your Email..' className='input-contact' onChange={(e)=>setEmail(e.target.value)} value={email}></input><br/>
//       Subject <input type="text" placeholder='Subject' className='input-contact'value={subject} onChange={(e)=>setSubject(e.target.value)} ></input><br/>
//       <textarea type="text" placeholder='Message' className='input-contact' cloumn="5"rows="10" value={body} onChange={(e)=>{setBody(e.target.value)}}></textarea>
//       <button onClick={Emailcall}>Submit</button>
// </td>
//         </tr>
//       </table> 
//        <div className='tableContact'>
//       <h2>Address</h2>
//       <h3>Kandivali</h3>
//          </div>
// <div>
//      <iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=12/Vanashri, Popat Compound, Appapada, Maharashtra Nagar Kurar Village, Malad East Mumbai, Maharashtra 400097 India&t=&z=14&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
//      </div> */}
     
//       {/* <LoadScript
//       googleMapsApiKey="AIzaSyAWeF1fSdxPgShP4oVmOeUmbIM2HIbbtoE"
//     >
//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={center}
//         zoom={10}
//       >
//         <></>
//       </GoogleMap>
//     </LoadScript> 

//     <div className='QMbmRe' ></div>

    
  )
}

export default Contact;